import { useState } from 'react';
import { useSelector } from 'react-redux';
import { exposeEventToPartner } from '../../Helpers/events';

const useFirstInteraction = () => {
  const [firstInteractionComplete, setFirstInteractionComplete] =
    useState(false);
  const { widgetLabel, iFrameId } = useSelector(
    (store) => store.optionalFormConfig
  );
  const { formId } = useSelector((store) => store.formConfig);

  const exposeInitialWidgetInteractionEvent = () => {
    if (!firstInteractionComplete) {
      setFirstInteractionComplete(true);
      exposeEventToPartner({
        eventType: 'initialWidgetInteraction',
        eventObject: {
          widgetLabel,
          iFrameId,
          formId: formId !== undefined ? String(formId) : undefined,
          formOriginId: process.env.NEXT_PUBLIC_SUBMISSION_ORIGIN_ID,
        },
      });
    }
  };

  return { exposeInitialWidgetInteractionEvent };
};

export default useFirstInteraction;
